<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 align-items-center">
      <button v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}" class="status-button" @click="status = ACTIVE_STATUS">{{ $t('active') }}</button> <span  v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}">({{activeCount}})</span> | <button v-bind:class="{'font-weight-bold': status == PENDING_APPROVAL_STATUS}" class="status-button" @click="status = PENDING_APPROVAL_STATUS">{{ $t('pendingApproval') }}</button> <span  v-bind:class="{'font-weight-bold': status == PENDING_APPROVAL_STATUS}">({{pendingApprovalCount}})</span> | <button v-bind:class="{'font-weight-bold': status == PENDING_CONFIRMATION_STATUS}" class="status-button" @click="status = PENDING_CONFIRMATION_STATUS">{{ $t('pendingConfirmation') }}</button> <span  v-bind:class="{'font-weight-bold': status == PENDING_CONFIRMATION_STATUS}">({{pendingConfirmationCount}})</span> |<button v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}" class="status-button" href="#" @click="status = ARCHIVE_STATUS">{{ $t('archive') }}</button> <span v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}">({{archiveCount}})</span>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <!-- Pop ups -->
    <UserPopUp :user="selectedUser" :rejectModal="showModal" @closeConfirmRequested="selectedUser = null" v-model="selectedUser"></UserPopUp>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import UserPopUp from "@/controls/popups/UserPopUp.vue";

const ACTIVE_STATUS = "Active";
const PENDING_APPROVAL_STATUS = "PendingApproval";
const PENDING_CONFIRMATION_STATUS = "PendingConfirmation";
const ARCHIVE_STATUS = "Archive";

export default {
  components: { CTableWrapper, SearchBar, UserPopUp },
  data () {
    return {
      status: '',
      selectedUser: null,
      searchText: '',
      showModal: true,
      caption: i18n.t('users'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'email', label: i18n.t('email'), _classes: 'font-weight-bold', sortable: true },
        { key: 'name', label: i18n.t('name'),  sortable: true },
      ],
      actions: [],
      sorterValue: { column: 'id', asc: false },
      loading: false,
      //
      ACTIVE_STATUS: ACTIVE_STATUS,
      PENDING_APPROVAL_STATUS: PENDING_APPROVAL_STATUS,
      PENDING_CONFIRMATION_STATUS: PENDING_CONFIRMATION_STATUS,
      ARCHIVE_STATUS: ARCHIVE_STATUS
    }
  },
  computed: {
    ...mapState('users', ['getUsersOutput']),
    ...mapState('users', ['getUserByIdOutput']),
    ...mapState('users', ['putUserChangeStatusOutput']),
    ...mapState('users', ['deleteUserOutput']),
    userInfo: function() {
      return this.getUsersOutput ? this.getUsersOutput : null;
    },
    items: function()
    {
      var result = [];

      if(this.userInfo && this.userInfo.data)
      {
        result = this.userInfo.data.users;
        result.forEach(user => 
        { 
          if(!user.name) user.name = "-";
        });
      }

      return result;
    },
    pages: function()
    {
      return this.userInfo ? this.userInfo.totalPages : 1;
    },
    activeCount: function()
    {
      return this.userInfo && this.userInfo.data ? this.userInfo.data.active : 0;
    },
    pendingApprovalCount: function()
    {
      return this.userInfo && this.userInfo.data ? this.userInfo.data.pendingApproval : 0
    },    
    pendingConfirmationCount: function()
    {
      return this.userInfo && this.userInfo.data ? this.userInfo.data.pendingConfirmation : 0;
    },
    archiveCount: function()
    {
      return this.userInfo && this.userInfo.data ? this.userInfo.data.archive : 0
    },
  },
  mounted: function()
  {
    this.status = ACTIVE_STATUS;
  },
  methods: {
    ...mapActions('users', ['getUsers']),
    ...mapActions('users', ['getUserById']),
    ...mapActions('users', ['deleteUser']),
    ...mapActions('users', ['putUserChangeStatus']),
    rowClicked (item) {
      this.actionClicked(item, {key: 'view'});
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.loading = true;
          this.showModal = false;
          this.getUserById(item.id);
          break;
        }
        case 'orders':
        {
          router.push({ name: 'OrdersList', query: { userId: item.id, userEmail: item.email }});
          break;
        }
        case 'disable':
        {
          if(confirm(this.$i18n.tc('confirmDisable', item.email, { name: item.email }))){
            this.putUserChangeStatus({ userId: item.id, status: ARCHIVE_STATUS });
          }
          break;
        }
        case 'enable':
        {
          if(confirm(this.$i18n.tc('confirmEnable', item.email, { name: item.email }))){
            this.putUserChangeStatus({ userId: item.id, status: ACTIVE_STATUS});
          }
          break;
        }
        case 'reject':
        {
          this.loading = true;
          this.showModal = true;
          this.getUserById(item.id);
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      // List specific parameters
      input.status = this.status;
      
      this.getUsers(input); 
    },
    addUser() 
    {
      router.push({ name: 'UserAdd', params: { type: this.$route.params.type }});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }
  },
  watch:
  {
    status: function (val) {
      // Update actions
      switch(val) {

        case ACTIVE_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'orders', label: this.$i18n.t("viewOrders") });
          this.actions.push({ key: 'disable', label: this.$i18n.t("disable") });
          
          break;
        }
        case PENDING_CONFIRMATION_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'reject', label: this.$i18n.t("reject") });

          break;
        }
        case PENDING_APPROVAL_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'enable', label: this.$i18n.t("enable") });
          this.actions.push({ key: 'reject', label: this.$i18n.t("reject") });

          break;
        }
        case ARCHIVE_STATUS:
        {
          this.actions = [];
        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'enable', label: this.$i18n.t("enable") });

          break;
        }
        default:
        {
          throw "The provided status is not supported!"; 
        }
      }

      // Update items
      this.$refs.table.reset();
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    getUserByIdOutput: function (output) {
      this.loading = output === null;

      if (!output && !output.data) {
        alert(this.$i18n.t("errorMsg"));
      }
      else {
        this.selectedUser = output.data;
      }
    },
    // deleteUserOutput: function(val) {
    //   this.loading = val === null;

    //   if (!output) {
    //     alert(this.$i18n.t("errorMsg"));
    //   }
    //   else {
    //     this.selectedUser = output.data;
    //   }

    // },
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteUserOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    putUserChangeStatusOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getUsersOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.actions
{
  gap: 2px;
}
</style>